export default __webpack_public_path__ + "static/media/mail.f117a731.svg";